import React from "react";
import AnnualUpgradeModalForm from "../AnnualUpgradeModalForm";
import FakePaypalButton from "./PaypalButton";
import FakeStripePaymentElement from "./StripePaymentElement";

export default function (props) {
  return (
    <AnnualUpgradeModalForm
      {...props}
      PaypalButton={FakePaypalButton}
      StripePaymentElement={FakeStripePaymentElement}
    />
  );
}
